import { LogOut } from 'lucide-react';

import { useAuth } from '../lib/auth.js';

export function UserCard() {
  const { admin, logout } = useAuth();
  if (!admin) return null;
  const initial = admin.adminEmail[0]?.toUpperCase() ?? 'A';
  const shortName = admin.adminEmail.split('@')[0] ?? admin.adminEmail;

  const handleLogout = () => {
    void logout();
  };

  return (
    <div className="flex items-center gap-3">
      <div className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-500 text-sm font-medium text-white">
        {initial}
      </div>
      <div className="min-w-0 flex-1">
        <div className="truncate text-sm font-medium text-slate-800 dark:text-slate-100">
          {shortName}
        </div>
        <div className="truncate text-xs text-slate-500 dark:text-slate-400">
          {admin.adminEmail}
        </div>
      </div>
      <button
        type="button"
        onClick={handleLogout}
        title="退出登录"
        aria-label="退出登录"
        className="rounded-md p-1.5 text-slate-500 hover:bg-slate-100 hover:text-slate-700 dark:hover:bg-slate-900 dark:hover:text-slate-100"
      >
        <LogOut className="h-4 w-4" />
      </button>
    </div>
  );
}
